import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-2 flex items-end space-x-2" }
const _hoisted_2 = { class: "text-3xl" }
const _hoisted_3 = { class: "text-center my-4 text-2xl" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pt-8" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-2xl mb-2" }, "Eliminar Cancha", -1)
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Vas a eliminar la cancha ")
const _hoisted_10 = {
  key: 0,
  class: "font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_table = _resolveComponent("ui-table")
  const _component_ui_text_input = _resolveComponent("ui-text-input")
  const _component_ui_text_select = _resolveComponent("ui-text-select")
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_modal = _resolveComponent("ui-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.routeName), 1),
      (_ctx.userStoreState && _ctx.userStoreState.role !== 'CONSULTOR' && _ctx.userStoreState.role !== 'SUPERVISOR')
        ? (_openBlock(), _createBlock("p", {
            key: 0,
            class: "cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModalToCreate && _ctx.openModalToCreate(...args)))
          }, "Crear"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ui_table, {
      headers: _ctx.tableHeaders,
      items: _ctx.tableItems,
      actions: _ctx.actions,
      clickable: true
    }, null, 8, ["headers", "items", "actions"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalState,
      "onUpdate:modalState": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalState = $event))
    }, {
      default: _withCtx(() => [
        _createVNode("p", _hoisted_3, [
          (_ctx.modalMode === 'CREATE')
            ? (_openBlock(), _createBlock("span", _hoisted_4, "Crear Cancha"))
            : (_ctx.modalMode === 'EDIT')
              ? (_openBlock(), _createBlock("span", _hoisted_5, "Editar Cancha"))
              : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ui_text_input, {
          ref: "codigoRef",
          placeholder: "Código",
          value: _ctx.formData.codigo,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.codigo = $event)),
          validations: ['required']
        }, null, 8, ["value"]),
        _createVNode(_component_ui_text_input, {
          ref: "nombreRef",
          placeholder: "Nombre",
          value: _ctx.formData.descripcion,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.descripcion = $event)),
          validations: ['required']
        }, null, 8, ["value"]),
        _createVNode(_component_ui_text_select, {
          ref: "tiposRef",
          label: "Tipo",
          items: _ctx.canchaTipos,
          onSelected: _cache[4] || (_cache[4] = (evt) => (_ctx.formData.tipo = evt)),
          required: true,
          default: _ctx.selectedTipoDefault
        }, null, 8, ["items", "default"]),
        _createVNode(_component_ui_text_select, {
          ref: "estadosRef",
          label: "Estado",
          items: _ctx.estados,
          onSelected: _cache[5] || (_cache[5] = (evt) => (_ctx.formData.estado = evt)),
          required: true,
          default: _ctx.selectedEstadDefault
        }, null, 8, ["items", "default"]),
        _createVNode(_component_ui_text_input, {
          placeholder: "Código SISCOP",
          ref: "siscopRef",
          value: _ctx.formData.codigoSISCOP,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.codigoSISCOP = $event)),
          validations: ['required']
        }, null, 8, ["value"]),
        _hoisted_6,
        (_ctx.modalMode === 'CREATE')
          ? (_openBlock(), _createBlock(_component_ui_button, {
              key: 0,
              label: "Crear Cancha",
              loading: _ctx.isLoading,
              onClick: _ctx.onCreateCancha
            }, null, 8, ["loading", "onClick"]))
          : (_ctx.modalMode === 'EDIT')
            ? (_openBlock(), _createBlock(_component_ui_button, {
                key: 1,
                label: "Guardar Cambios",
                loading: _ctx.isLoading,
                onClick: _ctx.onEditCancha
              }, null, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modalState"]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalRemovalState,
      "onUpdate:modalState": _cache[8] || (_cache[8] = ($event: any) => (_ctx.modalRemovalState = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_7,
        _createVNode("p", _hoisted_8, [
          _hoisted_9,
          (_ctx.selectedToRemoval)
            ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.selectedToRemoval.data.descripcion), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ui_button, {
          label: "Eliminar Cancha",
          loading: _ctx.isLoading,
          onClick: _ctx.onDeleteCancha
        }, null, 8, ["loading", "onClick"])
      ]),
      _: 1
    }, 8, ["modalState"])
  ], 64))
}